import { create } from 'zustand';

/**
 * Whether the image keeps gliding after a drag or a trackpad scroll is let go
 * (OpenLayers' kinetic pan, and macOS scroll momentum). Off by default: the
 * image stops where it is let go. The last choice is kept in this browser; the
 * community edition also keeps it on the account (`viewerGlide`).
 */
const KEY = 'tr.viewerGlide';

function stored(): boolean {
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export const useViewerGlide = create<{ glide: boolean; set: (glide: boolean) => void }>((set) => ({
  glide: stored(),
  set: (glide) => {
    try {
      window.localStorage.setItem(KEY, glide ? '1' : '0');
    } catch {
      /* private browsing: the choice lasts this page */
    }
    set({ glide });
  },
}));
